module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Chapter-Name",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "Chapter-word"
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-1"
    }
  }), _vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("I’m a military spouse, but I’ve never stood on a windy pier or tarmac dressed in red, white, and blue, holding a baby and waving an American flag. Variations on that image turn up unfailingly on television, online, or in print whenever the subject of military families arises. I often suspect a similar loop plays inside the heads of people I meet when they find out my husband serves in the military.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Yes, he’s been deployed several times. Cue the surprise homecoming footage: Uniformed dad popping out of a giant gift-wrapped box. Haven’t done that either. And I call myself a military wife?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Yes, I do.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("These well-known scenes are dramatic, poignant, and real. They are parts of the military story, but not the whole. Pictures speak more than a thousand words, but a thousand words or even ten thousand couldn’t convey the message of military life. Because there isn’t just one message. There isn’t just one story. There’s one for every person who lives it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("My father served two tours in Southeast Asia. He spent more peaceful tours in many other places, retiring after twenty years on active duty. My husband has been deployed five times during three combat operations: Desert Storm, Enduring Freedom and Iraqi Freedom. My family has certainly been touched by war and affected by it, but we have been shaped more by the ordinary events of our lives as a military family.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Military life touches the consciousness of our nation mostly through events that are heroic, scandalous, or tragic. When combat claims military lives, when a general is caught in infidelity, or a former sailor commits horrific crimes, there’s a concurrent spike in public interest. However, the quieter days, when no one is watching, are more indicative of our lives than big news events. Much of military life is noteworthy without being newsworthy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("I first began writing Spouse Calls for ")]), _c('span', {
    staticClass: "Text CharOverride-11"
  }, [_vm._v("Stars and Stripes")]), _c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v(" in 2007, when our nation was at war on two fronts. I wanted the column to include practical content, news, and helpful information for military families. But before long, smaller pieces of my life began to find their way into my work, from deployments and memorial services to packing lunches and baking cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("When I was trying to write a column, the daily events of my military life would stand at my elbow and whisper—or shout—that they were part of the message, too. I had no choice but to listen, and write. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("I’ve encountered wounded warriors while walking the halls of Walter Reed and Landstuhl, but I’ve never been to either hospital looking for a news story. I was there for a mammogram, perhaps, or to take one of my children for an eye appointment. This is where military families live our lives, in the intersection of conflict and the commonplace. Perhaps that’s the crux of military life, and the best place to find messages from the home front.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("In this collection of Spouse Calls columns, I don’t presume to tell the whole story of military life. I can only write about what I’ve seen, where I’ve been, whom I’ve met, contributing to the larger picture of military families, one that fleshes out the real people and real lives we live.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("These are just a few of the messages from military life.")])]), _vm._v(" "), _c('p', {
    staticClass: "Stars-End-Column"
  }, [_c('span', {
    staticClass: "Stars-End-Column _idGenCharOverride-6"
  }, [_vm._v("*** ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e46ee45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spousecalls3.vue
// module id = 66
// module chunks = 0